import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53')
];

export const server_loads = [];

export const dictionary = {
		"/": [18],
		"/about": [42],
		"/(authenticated)/account": [33,[2,11]],
		"/(authenticated)/account/[tab]": [34,[2,11,12]],
		"/confirm": [43],
		"/(authenticated)/dashboard": [35,[2]],
		"/(authenticated)/experimental": [36,[2,13]],
		"/(authenticated)/experimental/agents": [37,[2,13,14]],
		"/(authenticated)/experimental/agents/[tab]": [38,[2,13,14]],
		"/(authenticated)/experimental/float": [39,[2,13]],
		"/(authenticated)/experimental/hewsync": [40,[2,13,15]],
		"/(authenticated)/experimental/queue": [41,[2,13,16]],
		"/features": [44],
		"/forgot-password": [45],
		"/iframe": [46],
		"/login-as": [48],
		"/login": [47],
		"/logout": [49],
		"/markdown-preview": [50],
		"/reset-password": [51],
		"/share": [52,[],[17]],
		"/signup": [53],
		"/(authenticated)/[organization=organization]": [19,[2,3]],
		"/(authenticated)/[organization=organization]/api": [22,[2,3,6]],
		"/(authenticated)/[organization=organization]/api/[kind]/[id]/[[tab]]": [23,[2,3,6,7,8]],
		"/(authenticated)/[organization=organization]/dashboard": [24,[2,3]],
		"/(authenticated)/[organization=organization]/project/[id]/atom": [26,[2,3,10]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/chats/[chat]": [28,[2,3,10]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/plans/[plan]": [29,[2,3,10]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/reports/[report]": [30,[2,3,10]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/[...path]": [27,[2,3,10]],
		"/(authenticated)/[organization=organization]/project/[id]/files": [31,[2,3]],
		"/(authenticated)/[organization=organization]/project/[id]/files/[...path]": [32,[2,3]],
		"/(authenticated)/[organization=organization]/project/[id]/[...page]": [25,[2,3,9]],
		"/(authenticated)/[organization=organization]/[slug=perms]": [20,[2,3,4]],
		"/(authenticated)/[organization=organization]/[slug=perms]/[id]/[[tab]]": [21,[2,3,4,5]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';